<template>
  <v-alert v-model="showError" type="error" prominent>
    <v-row align="center">
      <v-col class="grow">
        <template v-for="(err, key) in errors">
          <div :key="key" v-html="err"></div>
        </template>
      </v-col>
      <v-col class="shrink">
        <v-btn fab small icon @click="clearErrors">
          <v-icon dark color="white">mdi-close-circle</v-icon>
        </v-btn>
      </v-col>
    </v-row>
  </v-alert>
</template>

<script>
export default {
  name: 'ErrorBlock',
  computed: {
    errors() {
      return this.$store.state.errors.errors;
    },
    showError() {
      return this.$store.state.errors.showError;
    },
  },
  methods: {
    clearErrors() {
      this.$store.commit('errors/clearAll');
    },
  },
};
</script>

<style scoped>

</style>
